import React, { useEffect, useState } from "react";
import axios from "axios";
import { Parallax } from "react-parallax";
import LoadingPage from "./LoadingPage";
import { useDocumentMeta } from '../useDocumentMeta';

function Detail(props) {
  window.scrollTo(0, 0);
  const [detailInfo, setDetailInfo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchDetail = async () => {
    try {
      setError(null);
      setDetailInfo(null);
      setLoading(true);
      const response = await axios.get(
        "https://api.0u0.kr/portfolio/detail/Itview"
      );
      setDetailInfo(response.data.data);
    } catch (e) {
      setError(e);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchDetail();
    //
  }, []);
  useDocumentMeta(detailInfo?.pjDetailBigName, detailInfo?.contentHdBgColor);

  if (loading) {
    return (
      <>
        <LoadingPage />
      </>
    );
  }
  if (error) return <div>에러가 발생했습니다.</div>;
  if (!detailInfo) return null;
  if (detailInfo) {
    props.setColorData(detailInfo.contentHdBgColor);
  }

  return (
    <>
      <div
        className="detailHeader"
        style={{ backgroundColor: detailInfo.contentBgColor }}
      >
        <div className="dhTb">
          <div className="dhTbCell">
            <div className="dhDiv">
              <div className="txtBox">
                <h3>{detailInfo.pjDetailSmName}</h3>
                <h1>{detailInfo.pjDetailBigName}</h1>
              </div>
              <div className="logoBox ">
                <div className="logoBoxPt">
                  <img
                    src={"https://img.0u0.kr/new_port/" + detailInfo.imgLogo}
                    alt={detailInfo.pjName + "의 로고"}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="whiteBg">
        <div className="detailInfo basicWidth topImgTxtStyle">
          <ul style={{ color: detailInfo.contentFontColor }}>
            <li>
              <div className="tit">카테고리</div>
              <h2>{detailInfo.tagName}</h2>
            </li>

            <li>
              <div className="tit">업무처</div>
              <h2>{detailInfo.teamName}</h2>
            </li>

            <li>
              <div className="tit">기간</div>
              <h2>{detailInfo.pjDate}</h2>
            </li>

            <li>
              <div className="tit">사용 툴/언어</div>
              <h2>{detailInfo.pjTool}</h2>
            </li>
          </ul>
        </div>
      </div>


      <Parallax
        bgImage="https://img.0u0.kr/new_port/itview_001.jpg"
        strength={500}
        className="topmobiImgStyle"
      >
        <div className="parallaxHeight "></div>
      </Parallax>

      <div className="whiteBg" style={{paddingTop:'15px'}}>
        <div className="detailInfo basicWidth topImgTxtStyle">
          <div className="basicDetailTitleBox">
            <h2>통합 선박 경제 운항 및 관리 시스템</h2>
            <div className="txtBox">
            전 세계에 흩어져 있는 선박들의 실시간 위치, 운항 상태, 엔진 성능 및 환경 규제(CII/DCS/MRV) 데이터를 통합 관리하는 해양 관제 솔루션입니다. 
            또한 선박의 대용량 데이터를 처리하기위해 PostgreSQL을 도입하여 데이터여, 방대한 데이터를 실시간으로 빠르고 정확하게 분석할 수 있는 탄탄한 기반을 갖췄습니다.
            </div>
          </div>

          <div class="txtGroupBox" style={{textAlign:'center'}}>
            <h2 class="leftAlign" style={{fontSize:'1.7em', marginTop:'90px'}}>🚀 프로젝트 개요</h2>
            <div style={{lineHeight:'150%', marginTop:'10px'}}>
              목적 : 선박 운항 데이터의 실시간 시각화, 효율 분석, 유지보수 및 국제 해사 규제 대응<br/>
              주요 타겟 : 선사, 선박 관리사, 운항 관리자<br/>
              참여 핵심 기능 : 탄소 배출량 관리, 실시간 기상 데이터 표시
            </div>
          </div>


          <div class="txtGroupBox" style={{textAlign:'center'}}>
            <h2 class="leftAlign" style={{fontSize:'1.7em', marginTop:'50px'}}>🛠️ 주요 기술 스택</h2>
            <div style={{lineHeight:'150%', marginTop:'10px'}}>
              Backend :  Java (Spring), Mybatis, MySQL, PostgreSQL<br/>
              FrontEnd : Mapbox, ZingChart, LightningChart<br/>
            </div>

          </div>


        </div>



      </div>

      <div className="whiteBg">
          <div class="detailInfo basicWidth topImgTxtStyle">
            <div className="basicDetailTitleBox ">
                <div className="imgGroupBox">
                  <img
                    src="https://img.0u0.kr/new_port/itview_002.jpg"
                    className="bdImgBox"
                    alt=""
                  />
                </div>
                <div className="txtGroupBox">
                  <h2 className="leftAlign">대용량 데이터 표시</h2>
                  <div className="txtBox">
                    1초 단위로 수집되는 데이터를 표시하기위해, 일반적인 RDBMS대신 PostgreSQL를 도입하여 초당 수만 건의 데이터를 불러와서 데이터를 차트로 표시
                  </div>
                  
                  <div className="blnakHeight10" style={{height:'50px'}}></div>
                  <h2 className="leftAlign">국제 해사 환경 규제(CII/ETS/MRV) 대응</h2>
                  <div className="txtBox">
                    IMO(국제해사기구) 및 EU의 탄소 배출 규제에 대응하기 위한 각종 규제 계산 알고리즘 적용
                  </div>
                  
                  <div className="blnakHeight10" style={{height:'50px'}}></div>
                  <h2 className="leftAlign">기상 데이터 표시</h2>
                  <div className="txtBox">
                  외부 기상 API를 호출해 DB에 저장하고, Mapbox를 연동하여 태풍, 파고 등 기상 상황을 지도상에 레이어로 구현했습니다.
                  </div>
                </div>
              </div>
        </div>
    </div>

    </>
  );
}
export default Detail;
